module.exports = __webpack_public_path__ + "static/media/logo_horizontal.b41539f8.png";